<div class="card h-100 shadow-sm {{theme$ | async}}">
  <lib-card
    [fullScreenMode]="true"
    [fullHeight]="true"
    >
    <lib-card-header>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 d-flex flex-wrap align-items-center">
            <div class="d-flex font-weight-bold text-primary font-size-normal mr-3 mr-sm-auto">
              {{'POWER_FORECAST.TITLE' |translate}}
              @if (!powerForecast) {
                <app-spinner></app-spinner>
              }
            </div>
            <div class="d-flex flex-wrap mt-3 mt-md-0 content-box-buttons">
              <div class="mr-3 custom-arrow">
                <lib-select
                  id="power-forecast-select-provider"
                  [options]="forecastOptions"
                  [label]="actualValue"
                  [border]="'custom-border'"
                  [classes]="'font-size-normal-small text-primary h-100'"
                  [notBold]="true"
                  [fullWidth]="false"
                  [itemClasses]="'font-size-normal-small'"
                  [container]="''"
                  [size]="'small'"
                  (selectedChanged)="handleProviderChanged($event)">
                </lib-select>
              </div>
              <div class="mr-3 d-flex align-items-center">
                <lib-content-box-buttons
                  [active]="activeButton"
                  [buttons]="contentButtons"
                  (activeChanged)="handleActiveChanged($event)">
                </lib-content-box-buttons>
              </div>
            </div>
          </div>
        </div>
      </div>
    </lib-card-header>
    <lib-card-body>
      @if ((reload | async)) {
        <div id="powerForecastChartWrapper">
          @if (page == 'park-monitor' && weatherData) {
            <app-monitoring-weather
              [weatherData]="weatherData"
            ></app-monitoring-weather>
          }
          <app-power-forecast-chart
            [powerForecast]="powerForecast"
            [page]="page">
          </app-power-forecast-chart>
        </div>
      }
    </lib-card-body>
  </lib-card>
</div>
